// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AddOnQuantityController from "./add_on_quantity_controller"
application.register("add-on-quantity", AddOnQuantityController)

import AiFeaturesController from "./ai_features_controller"
application.register("ai-features", AiFeaturesController)

import AlertFormController from "./alert_form_controller"
application.register("alert-form", AlertFormController)

import AlertsBulkController from "./alerts_bulk_controller"
application.register("alerts-bulk", AlertsBulkController)

import AutoDismissController from "./auto_dismiss_controller"
application.register("auto-dismiss", AutoDismissController)

import AutoHideController from "./auto_hide_controller"
application.register("auto-hide", AutoHideController)

import AutoScrollController from "./auto_scroll_controller"
application.register("auto-scroll", AutoScrollController)

import BillingToggleController from "./billing_toggle_controller"
application.register("billing-toggle", BillingToggleController)

import BrandingController from "./branding_controller"
application.register("branding", BrandingController)

import ChangelogDrawerController from "./changelog_drawer_controller"
application.register("changelog-drawer", ChangelogDrawerController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import ComparePickerController from "./compare_picker_controller"
application.register("compare-picker", ComparePickerController)

import CookieDismissController from "./cookie_dismiss_controller"
application.register("cookie-dismiss", CookieDismissController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import DebounceController from "./debounce_controller"
application.register("debounce", DebounceController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DigestPreferencesController from "./digest_preferences_controller"
application.register("digest-preferences", DigestPreferencesController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EndpointKindController from "./endpoint_kind_controller"
application.register("endpoint-kind", EndpointKindController)

import EmailReplayController from "./email_replay_controller"
application.register("email-replay", EmailReplayController)

import EmailTabsController from "./email_tabs_controller"
application.register("email-tabs", EmailTabsController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import FeatureRequestModalController from "./feature_request_modal_controller"
application.register("feature-request-modal", FeatureRequestModalController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import HeaderRevealController from "./header_reveal_controller"
application.register("header-reveal", HeaderRevealController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import KeywordListController from "./keyword_list_controller"
application.register("keyword-list", KeywordListController)

import LoadingController from "./loading_controller"
application.register("loading", LoadingController)

import MetricsRefreshController from "./metrics_refresh_controller"
application.register("metrics-refresh", MetricsRefreshController)

import NewRequestsController from "./new_requests_controller"
application.register("new-requests", NewRequestsController)

import NotificationChannelFormController from "./notification_channel_form_controller"
application.register("notification-channel-form", NotificationChannelFormController)

import NotifyOnceToggleController from "./notify_once_toggle_controller"
application.register("notify-once-toggle", NotifyOnceToggleController)

import PlanSelectorController from "./plan_selector_controller"
application.register("plan-selector", PlanSelectorController)

import ProviderSelectorController from "./provider_selector_controller"
application.register("provider-selector", ProviderSelectorController)

import RawDiffToggleController from "./raw_diff_toggle_controller"
application.register("raw-diff-toggle", RawDiffToggleController)

import ReplayFormController from "./replay_form_controller"
application.register("replay-form", ReplayFormController)

import ReplayModalController from "./replay_modal_controller"
application.register("replay-modal", ReplayModalController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SlackChannelPickerController from "./slack_channel_picker_controller"
application.register("slack-channel-picker", SlackChannelPickerController)

import SignatureConfigFormController from "./signature_config_form_controller"
application.register("signature-config-form", SignatureConfigFormController)

import StripeElementsController from "./stripe_elements_controller"
application.register("stripe-elements", StripeElementsController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TimezoneController from "./timezone_controller"
application.register("timezone", TimezoneController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TomselectController from "./tomselect_controller"
application.register("tomselect", TomselectController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TryCtaController from "./try_cta_controller"
application.register("try-cta", TryCtaController)

import TurboFrameController from "./turbo_frame_controller"
application.register("turbo-frame", TurboFrameController)

import UrlPreviewController from "./url_preview_controller"
application.register("url-preview", UrlPreviewController)
